import {TableColumn} from "react-data-table-component";
import {generateGuid, getLabelName} from "../../../utils";
import {
    AccountAcBeginBalanceTypeEnum,
    GridChangeTypeEnum,
    TextBoxVersionEnum,
    TransactionRowDataModel,
} from "../../../models";
import {ButtonBox, TextBox} from "../..";

interface TransactionHandlers {
    handleDeletion: (id: string) => void;
    handleTransactionModification: (id: string,type:GridChangeTypeEnum, value?: number, note?: string) => void;
}

const setCurrentTransactionColumns: (
    handlers: TransactionHandlers
) => TableColumn<TransactionRowDataModel>[] = ({
                                              handleDeletion,
                                                                                       handleTransactionModification,
                                          }) => {
    const handleValueChange = (event: any, id: string) => {
        const enteredValue = event.target.value;
        if (+enteredValue < 1) return;
        handleTransactionModification(id,GridChangeTypeEnum.Amount, enteredValue,undefined);
    };
    const handleNotesChange = (event: any, id: string) => {
        handleTransactionModification(id,GridChangeTypeEnum.Note, undefined, event.target.value);
    };
    const currentTransactionColumns: TableColumn<TransactionRowDataModel>[] = [
        {
            name: getLabelName("To Account"),
            selector: (row) => getLabelName(row.toAccount?.label || ""),
            sortable: true,
            wrap: true,
            allowOverflow: true,
        },
        {
            name: getLabelName("Debit"),
            id: "total_debit_column",
            width: "200px",
            cell: ({amount, valueType, id}) => (
                <TextBox
                    inputValue={
                        valueType === AccountAcBeginBalanceTypeEnum.DebitAccount
                            ? amount
                            : "0"
                    }
                    labelName=""
                    inputName="creditValue"
                    type="number"
                    isReadOnly={valueType !== AccountAcBeginBalanceTypeEnum.DebitAccount}
                    onChange={(value: any) => handleValueChange(value, id)}
                ></TextBox>
            ),
            sortable: true,
            wrap: true,
            allowOverflow: true,
        },
        {
            name: getLabelName("Credit"),
            width: "200px",
            id: "total_credit_column",
            cell: ({amount, valueType, id}) => (
                <TextBox
                    inputValue={
                        valueType === AccountAcBeginBalanceTypeEnum.CreditAccount
                            ? amount
                            : "0"
                    }
                    labelName=""
                    inputName="creditValue"
                    type="number"
                    isReadOnly={valueType !== AccountAcBeginBalanceTypeEnum.CreditAccount}
                    onChange={(value: any) => handleValueChange(value, id)}
                ></TextBox>
            ),
            sortable: true,
            allowOverflow: true,
        },
        {
            name: getLabelName("Note"),
            id: "remarks_column",
            grow: 5,
            minWidth: "300px",
            width: "auto",
            maxWidth: "1fr",
            cell: (row) => (
                <div style={{ width: "100%", display: "flex" }}>
                    <TextBox
                        inputName="remarks"
                        type={"text"}
                        labelName=""
                        inputValue={row.remarks}
                        onChange={(value: any) => handleNotesChange(value, row.id)}
                        version={TextBoxVersionEnum.V2}
                        resetKey={generateGuid()}
                    ></TextBox>
                </div>
            ),
            sortable: true,
            //sortFunction: caseInsensitiveSort,
            //wrap: true,
            allowOverflow: true,
        },
        {
            button:true,
            // eslint-disable-next-line react/button-has-type
            cell: (row) => (
                <ButtonBox
                iconType="delete"
                    id="deleteBalanceButton"
                    variant="danger"
                    className="btn-xs"
                    onClick={() => handleDeletion(row.id)}
                >
                    {getLabelName("Delete")}
                </ButtonBox>
            ),
        },
    ];

    return currentTransactionColumns;
};

export default setCurrentTransactionColumns;
